import { apiV1 } from '~/services/api';

const getVersioning = () =>
  apiV1.request({
    url: '/v1/ui/account/version',
  });

const upgradeVersioning = () =>
  apiV1.request({
    data: {
      update: true,
    },
    method: 'POST',
    url: 'v1/ui/account/version',
  });

export { getVersioning, upgradeVersioning };
